import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: authRoles.producer, routes: [{ path: '/production-payout', component: FuseLoadable({ loader: () => import('./peiReport') }) }] };

export default [Index];
